import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import { Box } from "@mui/material";

import sponsorsData from "../data/sponsors.json";

const Image = ({ url }) => {
   return <img alt='sponsor'
      src={url} />;
};

export const SponsorSectionTest = () => {
   const [sponsors, setSponsors] = useState([]);

   useEffect(() => {
      //for event that didn't finish yet
      // getData("https://youngstartup.io/api/cwebsite/get_sponsors").then((data) =>
      //   setSponsors(data)
      // );

      //for event that finished
      setSponsors(sponsorsData);
   }, []);

   return (
      <Box sx={{ flexGrow: 1 }}>
         {sponsors.length > 0 && <h1 style={{ textAlign: "center", fontWeight: "900", padding: "60px" }}>OUR PARTNERS</h1>}

         {sponsors.map(sponsor_type => {
            const { name, values } = sponsor_type;
            return (
               <Box key={Math.random()} sx={{
                  flexGrow: 1, width: "90%",
                  marginLeft: "auto",
                  marginRight: "auto"
               }}>
                  <h3
                     style={{
                        backgroundColor: "black",
                        width: "100%",
                        textAlign: "center",
                        color: "white",
                        padding: ".5%",
                     }}
                  >
                     {name.toUpperCase().replace(/_/g, " ")}
                  </h3>
                  <br />
                  <Grid container
                     spacing={2}
                     justifyContent="space-around"
                     style={{
                        padding: "30px",
                     }}
                  >
                     {values.map((sponsor, i) => (
                        <Grid
                           item
                           xs={12}
                           sm={6}
                           md={values.length === 4 ? 6 : 4}
                           key={i}
                           justifyContent="center"
                           textAlign="center"
                        >
                           <a href={sponsor.website}>
                              <Image url={sponsor.logo_url} />
                           </a>
                        </Grid>
                     ))
                     }
                  </Grid>
               </Box>
            )
         })}
      </Box>
   );
};
